import React from "react";
import { $t } from '@/modules/i18n';
import { transformArray } from '@/utils/helper';

export default ({ message = {}, id, children }) => (
  <section id={id ? id : 'timeline'} className="common-timeline">
    <h2 className="section-title">{$t(message.title)}</h2>
    {
      message.desc ? <p className="section-desc">{$t(message.desc)}</p> : null
    }
    <div className="content">
      <div className="line">
        {
          (message.list || []).map((item) => {
            if ($t(item.title)) {
              const descList = transformArray(item.desc)
              return (
                <div className="time" key={item.title}>
                  {
                    item.date ? <div className="date">{$t(item.date)}</div> : null
                  }
                  <div className="icon-wrapper">
                    <span className="dashed"></span>
                    {message.listIcon ? <img className="icon" src={message.listIcon} alt="point icon" /> : null}
                  </div>
                  <div className="timeline-content">
                    <h4 className="title">{$t(item.title)}</h4>
                    {descList.map(d => <p className="desc" dangerouslySetInnerHTML={{ __html: d }} key={d} />)}
                  </div>
                </div>
              )
            }
          })
        }
      </div>
      {
        message.explain ?
          (
            Array.isArray(message.explain)
              ? message.explain.map(desc => <p className="explain" key={desc}>{$t(desc)}</p>)
              : <p className="explain">{$t(message.explain)}</p>
          ) : null
      }
    </div>
    {
      children ? children : null
    }
  </section>
);